import { SnapshotDataItemsModel, ZlibSnapshotData } from '@tencent/slide-sdk-persistent/src/snapshot-manager';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IPresentationData, ISlideFileData } from '@tencent/slide-sdk-model';
import { statusReport007 } from '@src/slide/infrastructure/module/dependent/report/real-time-report/real-time';
import { Reporter007ActionType, Reporter007 } from '@src/slide/infrastructure/module/dependent/report/real-time-report/constant';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';

interface RawData {
    keyframe: ISlideFileData;
    object: IPresentationData;
}

export const getSnapshotKeyframeFromDB = async (
    snapshot: SnapshotDataItemsModel,
    keyframeWithPage?: boolean,
): Promise<ISlideFileData> => {
    const rawData = await snapshot.getPayload<RawData>();
    const { keyframe, object } = rawData;
    if (!keyframe && !object) {
        window.log.error('[Snapshot] invalid snapshot data, keys: ', Object.keys(rawData));
        throw 'invalid data';
    }

    const presentationStore = await SlideDataServices.SDKDataServices.PresentationStoreService.promise();
    let payload;
    if (keyframe) {
        payload = keyframe;
    } else {
        try {
            const newPresentation = presentationStore
                ?.createFromData(object);
            payload = keyframeWithPage
                ? newPresentation?.getSerializedPresentationDataWithPage()
                : newPresentation?.getSerializedPresentationData();
        } catch (error) {
            statusReport007(Reporter007ActionType.TRANSFORM_KEYFRAME_FAILED, Reporter007.ERROR);
            window.log.error('[Snapshot] transform object to keyframe failed', error);
            throw 'transform to keyframe failed';
        }
    }
    // 二次兜底，走一遍 apply 流程，清除脏数据
    const newPresentation = presentationStore?.createFromSlideFileData(payload);
    return keyframeWithPage
        ? newPresentation.getSerializedPresentationDataWithPage()
        : newPresentation.getSerializedPresentationData();
};

/** 使用 db 中的快照数据导出 */
export const exportSnapshotFromDB = async (snapshot: SnapshotDataItemsModel) => {
    const payload = await getSnapshotKeyframeFromDB(snapshot);
    const zipped = await new ZlibSnapshotData(payload).serialize();
    const apiService = await OnlineEditServices.OnlineApiService.promise();

    return apiService.asyncExportSnapshot({
        docId: snapshot.globalPadId,
        content: zipped.data,
        version: SlideDataServices.ClientVarsService()?.getClientVars().collab_client_vars?.dver,
    });
};

/** 使用当前的数据导出 */
export const exportCurrentDataAsSnapshot = async () => {
    const payload = SlideDataServices.SDKDataServices.PresentationStoreService()?.getSerializedPresentationData();
    const docId = SlideDataServices.ClientVarsService()?.getClientVars().globalPadId ?? '';

    const zipped = await new ZlibSnapshotData(payload).serialize();
    const apiService = await OnlineEditServices.OnlineApiService.promise();

    return apiService.asyncExportSnapshot({
        docId,
        content: zipped.data,
        version: SlideDataServices.ClientVarsService()?.getClientVars().collab_client_vars?.dver,
    });
};

// eslint-disable-next-line arrow-body-style
export const exportSnapshot = async (snapshot?: SnapshotDataItemsModel) => {
    return snapshot ? exportSnapshotFromDB(snapshot) : exportCurrentDataAsSnapshot();
};
